export default "__VITE_ASSET__1BjX$u1q__"